import { render, staticRenderFns } from "./DataSourceDataIdCombobox.vue?vue&type=template&id=18370e49&"
import script from "./DataSourceDataIdCombobox.vue?vue&type=script&lang=js&"
export * from "./DataSourceDataIdCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
